import React from 'react';
import { Box } from '../../../box';
import { FormControl } from '../../../form-control/form-control';
import { Container } from '../../../container/container';
import { Row } from '../../../row/row';
import { Cell } from '../../../cell/cell';
import { UserLookup } from '../../../lookups/user-lookup/user-lookup';
import { TeamLookup } from '../../../lookups/team-lookup/team-lookup';
import { FormDialog } from '../../../form-dialog/form-dialog';

export interface IAssignCaseworkerCourseDialogComponentProps {
  teamId?: string;
  userId?: string;
  isLoading?: boolean;
  onTeamChange: (team: string | undefined) => void;
  onUserChange: (userId: string | undefined) => void;
  isOpen: boolean;
  onConfirm: () => void;
  onClose?: () => void;
}

export function AssignCaseworkerCourseDialogComponent({
  teamId,
  userId,
  onTeamChange,
  onUserChange,
  isOpen,
  onConfirm,
  onClose,
  isLoading,
}: IAssignCaseworkerCourseDialogComponentProps) {
  return (
    <FormDialog
      open={isOpen}
      title="Tildel ansvarlig sagsbehandler og team"
      confirmButtonText="Udfør"
      cancelButtonText="Afbryd"
      isLoading={isLoading}
      onConfirmClick={onConfirm}
      onClose={onClose}
      onCancelClick={onClose}
      maxWidth="lg"
      isValid
    >
      <FormControl fullWidth>
        <Container>
          <Box width="1000px">
            <Row>
              <Cell size="full">
                <UserLookup value={userId} onChange={onUserChange} />
              </Cell>
              <Cell size="full">
                <TeamLookup required value={teamId} onChange={onTeamChange} />
              </Cell>
            </Row>
          </Box>
        </Container>
      </FormControl>
    </FormDialog>
  );
}
